import { apiClient } from "./ApiClient";

export async function fetchTransactionsAdmin({ skip, limit, sort_by, sort_order, filters }) {
  const params = new URLSearchParams({ skip, limit, sort_by, sort_order });

  for (const key in filters) {
    if (filters[key] !== null && filters[key] !== "") {
      if (key === "success") {
        params.append(key, filters[key] === "true");
      } else {
        params.append(key, filters[key]);
      }
    }
  }

  const response = await apiClient.get(`/transaction/batch/admin?${params}`);
  return response.data;
}

export async function requestRefund(transactionId, reason = "Cannot install eSIM") {
  try {
    const params = new URLSearchParams({ transaction_id: transactionId, reason: reason });
    const response = await apiClient.post(`/transaction/refund/request?${params}`);
    return response.data;
  } catch (error) {
    const err = new Error(error.response?.data?.detail || "Failed to request refund");
    err.status = error.response?.status || error.request?.status || error.status;
    err.response = error.response?.data;
    throw err;
  }
}

export async function refundTransactionService(transactionId) {
  try {
    const response = await apiClient.patch(`/transaction/refund/internal`, null, {
      params: { transaction_id: transactionId },
    });

    return response.data;
  } catch (error) {
    const errorData = error.response?.data || {};
    let errorMessage = "Failed to refund transaction to user wallet";

    if (
      (error.response?.status === 400 || error.response?.status === 422) &&
      errorData.detail &&
      Array.isArray(errorData.detail)
    ) {
      errorMessage = errorData.detail.map((err) => err.msg).join(", ");
    } else if (typeof errorData.detail === "string" && errorData.detail.trim()) {
      errorMessage = errorData.detail;
    } else if (errorData.description) {
      errorMessage = errorData.description;
    }

    const err = new Error(errorMessage);
    err.status = error.response?.status || error.request?.status || error.status;
    err.response = errorData;
    throw err;
  }
}

export async function refundTransactionBank(transactionId) {
  try {
    const response = await apiClient.patch(`/transaction/refund/top-up`, null, {
      params: { transaction_id: transactionId },
    });

    return response.data;
  } catch (error) {
    const errorData = error.response?.data || {};
    let errorMessage = "Failed to refund transaction to bank";

    if (
      (error.response?.status === 400 || error.response?.status === 422) &&
      errorData.detail &&
      Array.isArray(errorData.detail)
    ) {
      errorMessage = errorData.detail.map((err) => err.msg).join(", ");
    } else if (typeof errorData.detail === "string" && errorData.detail.trim()) {
      errorMessage = errorData.detail;
    } else if (errorData.description) {
      errorMessage = errorData.description;
    }

    const err = new Error(errorMessage);
    err.status = error.response?.status || error.request?.status || error.status;
    err.response = errorData;
    throw err;
  }
}

export async function fetchInvoicePdf(transactionId) {
  const response = await apiClient.get(`/transaction/invoices/${transactionId}`, {
    responseType: "blob",
    headers: { Accept: "application/pdf" },
  });

  const contentDisposition = response.headers?.["content-disposition"];
  const contentType = response.headers?.["content-type"] || "application/pdf";

  return { blob: response.data, contentDisposition, contentType };
}

export async function fetchTransactionInvoices({ date_start_inclusive, date_end_exclusive, user_id }) {
  const params = new URLSearchParams({
    date_start_inclusive,
    date_end_exclusive,
  });

  if (user_id) {
    params.append("user_id", user_id);
  }

  const response = await apiClient.get(`/transaction/invoices?${params.toString()}`, {
    responseType: "blob",
    headers: {
      Accept: "application/zip, application/octet-stream",
    },
  });

  return {
    blob: response.data,
    contentDisposition: response.headers?.["content-disposition"],
    contentType: response.headers?.["content-type"] || "application/zip",
  };
}
